import { DefaultHardStop } from "components/AppendixScreen/DefaultHardStop";
import {
  NOT_AUTHORISED_ATTESTATION_HEADER,
  NOT_AUTHORISED_ATTESTATION_MESSAGE,
} from "./HardStops.const";

export const UnAuthSigHardstop = () => {
  document.title = NOT_AUTHORISED_ATTESTATION_HEADER;
  return (
    <DefaultHardStop header={NOT_AUTHORISED_ATTESTATION_HEADER}>
      {NOT_AUTHORISED_ATTESTATION_MESSAGE}
    </DefaultHardStop>
  );
};
